import useStores from 'hooks/useStores';
import { Filter, SearchMode } from 'model/Filters';
import { PropsWithChildren } from 'react';

interface FiltersProviderState {
  filters: {
    activeFilters: Filter[];
    country: string;
    city: string;
    page: number;
  };
  adults: Filter;
  children: Filter;
  mode: SearchMode;
}

interface FiltersProviderProps {
  children: (e: FiltersProviderState) => any;
}

function FiltersProvider({
  children,
}: PropsWithChildren<FiltersProviderProps>) {
  const { filters, mode } = useStores(['FiltersStore'], (flux) => ({
    filters: flux.stores.FiltersStore.getFilters(),
    mode: flux.stores.FiltersStore.getSearchMode(),
  }));

  return children({
    filters,
    adults: filters.activeFilters.find(
      (filter: Filter) => filter.uid === 'adults',
    ),
    children: filters.activeFilters.find(
      (filter: Filter) => filter.uid === 'children',
    ),
    mode: mode as SearchMode,
  });
}

export default FiltersProvider;
